import { useState, useEffect } from 'react';

export default function CookieNotice() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    const dismissed = localStorage.getItem('cookieNoticeDismissed');
    // Show if no consent has been given and notice hasn't been dismissed
    if (!consent && !dismissed) {
      setShow(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'all');
    localStorage.setItem('cookieNoticeDismissed', 'true');
    setShow(false);
    // Note: Actual initialization of AdSense and Analytics would happen here
    // or be checked in App.jsx and AdSense components based on consent
  };

  const handleEssentialOnly = () => {
    localStorage.setItem('cookieConsent', 'essential');
    localStorage.setItem('cookieNoticeDismissed', 'true');
    setShow(false);
    // Note: AdSense and Analytics should be blocked when consent is 'essential'
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-gray-900 text-white p-4 z-50 shadow-2xl">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-start gap-3">
          <div className="flex-shrink-0 text-2xl">🍪</div>
          <div className="flex-1">
            <p className="text-sm font-medium mb-2">
              Cookie Notice
            </p>
            <p className="text-sm text-gray-300 mb-3">
              We use cookies for advertising and analytics. 
              By clicking "Accept," you consent to cookies as described in our{' '}
              <a href="/privacy#cookies" className="underline font-semibold text-purple-400 hover:text-purple-300">
                Privacy Policy
              </a>.
            </p>
            <div className="flex flex-wrap gap-3">
              <button 
                onClick={handleAccept}
                className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 font-medium text-sm"
              >
                Accept All Cookies
              </button>
              <button 
                onClick={handleEssentialOnly}
                className="px-4 py-2 bg-gray-700 text-white rounded-lg hover:bg-gray-600 font-medium text-sm"
              >
                Essential Only
              </button>
              <a 
                href="/privacy#cookies"
                className="px-4 py-2 text-gray-300 hover:text-white underline text-sm"
              >
                Cookie Settings
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

